// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_ProbingQuestions from "../Ouroboros.Models.Brands.ProbingQuestions/index.js";
import * as Ouroboros_Models_Brands_SectionID from "../Ouroboros.Models.Brands.SectionID/index.js";
import * as Ouroboros_Models_Brands_SectionIndex from "../Ouroboros.Models.Brands.SectionIndex/index.js";
import * as Ouroboros_Models_Brands_SectionStatus from "../Ouroboros.Models.Brands.SectionStatus/index.js";
import * as Ouroboros_Models_Documents_Documents from "../Ouroboros.Models.Documents.Documents/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var readRecord = /* #__PURE__ */ Simple_JSON.readRecord();
var readRecord1 = /* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "metadata";
    }
})(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Ouroboros_Models_Brands_SectionID.readSectionID)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(Ouroboros_Models_Brands_SectionIndex.readSectionIndex)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "last_edited";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(Simple_JSON.readString)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "status";
    }
})(Ouroboros_Models_Brands_SectionStatus.readSectionStatus)(Simple_JSON.readFieldsNil)()())()())()())()())()()))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "section_contents";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Simple_JSON.readString))(Simple_JSON.readFieldsNil)()())()());
var validateSection = Ouroboros_Models_Documents_Documents.validateSection;
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var readJson1 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "updated_section";
    }
})(readRecord1)(Simple_JSON.readFieldsNil)()()));
var readJson2 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "probing_questions";
    }
})(Ouroboros_Models_Brands_ProbingQuestions.readProbingQuestions)(Simple_JSON.readFieldsNil)()()));
var readJson3 = /* #__PURE__ */ readJson(/* #__PURE__ */ readRecord(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "new_section";
    }
})(readRecord1)(Simple_JSON.readFieldsNil)()()));
var failWith = function (message) {
    return new Data_Either.Left(message);
};
var decodeReplaceSectionResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $77 = validateSection(decoded.updated_section);
        if ($77) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid section replacement payload");
    });
};
var decodeRefineResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $78 = validateSection(decoded.updated_section);
        if ($78) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid section refine payload");
    });
};
var decodeGenerateSectionQuestionsResponse = function (value) {
    return readJson2(value);
};
var decodeGenerateDocumentQuestionsResponse = function (value) {
    return readJson2(value);
};
var decodeAppendSectionResponse = function (value) {
    return bind(readJson3(value))(function (decoded) {
        var $79 = validateSection(decoded.new_section);
        if ($79) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid section append payload");
    });
};
var decodeAnswerSectionQuestionsResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $80 = validateSection(decoded.updated_section);
        if ($80) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid section update payload");
    });
};
export {
    decodeGenerateSectionQuestionsResponse,
    decodeAnswerSectionQuestionsResponse,
    decodeReplaceSectionResponse,
    decodeRefineResponse,
    decodeGenerateDocumentQuestionsResponse,
    decodeAppendSectionResponse
};
//# sourceMappingURL=index.js.map
